import { useMutation } from '@tanstack/react-query'
import { ExtendableMutationOptions } from 'shared/api/api.types'

import { forgeApi } from '../..'
import { ShareArtifactRequest } from './shareArtifact.types'

export const shareArtifact = async ({
  publicId,
  users
}: ShareArtifactRequest): Promise<void> => {
  // Send rich recipients so forge stores name/avatar (shown in the share list).
  const recipients = users.map(u => ({
    id: u.id,
    name: u.name,
    avatar: u.avatar,
    email: u.email
  }))
  await forgeApi.post(
    `/api/v1/artifacts/${encodeURIComponent(publicId)}/shares`,
    {
      recipients
    }
  )
}

export const useShareArtifactMutation = (
  options?: ExtendableMutationOptions<void, ShareArtifactRequest>
) =>
  useMutation({
    mutationFn: shareArtifact,
    ...options
  })
